<template>
	<div id="newQianniuex" style="max-width:100%;">
		<input ref="fileInputThird" type="file" accept=".csv" style="display:none" @change="onThirdFileChange" />
		<el-tabs tab-position="left" v-model="tabCurrent" @tab-click="handleClick">
			<!--第1步 登录千牛-->
			<el-tab-pane name="first">
				<div slot="label" class="tab-slot">
					<p class="title">1、登录千牛</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="startvideo" class="startvideo">
                    <div class="tip">
                        <p><i class="el-icon-video-play"></i></p>
                        <p>
                            <a class="startstudy" @click="startVideo">开始学习</a>
                        </p>
                    </div>
                </div>
				<div id="video-first" class="video-box">
					<video id="first" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step1.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-first" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-first" class="content">
					<div class="con-left" style="padding: 0;">
						<StepPlayer
							ref="playerFirst"
							:steps="scenarioConfig.first.steps"
							:initial-step-id="scenarioConfig.first.initialStepId"
							:initial-form="scenarioConfig.first.initialForm"
							:show-tip="false"
							@finish="onFinish('first')"
							@guard-failed="onGuardFailed('first', $event)"
							@step-change="(stepId, step, resolvedTip) => onStepChange('first', stepId, step, resolvedTip)"
						/>
					</div>
					<div class="con-right">
						<h3><span class="line"></span>提示</h3>
						<div class="tip-body">
							<template v-if="tabCurrent === 'first' && currentStepId.first === 'login'">
								<p>1.复制粘贴账号和密码</p>
								<p>2.勾选记住密码</p>
								<el-button
									v-if="!showLoginPassword"
									type="primary"
									size="mini"
									@click="showLoginPassword = true"
								>
									获取账号密码
								</el-button>
								<template v-if="showLoginPassword">
									<p><span style="color: red;font-weight:normal;">账号：淘金云客服:小淘</span></p>
									<p><span style="color: red;font-weight:normal;">密码：Tj1234</span></p>
								</template>
							</template>
							<template v-else>
								<div v-html="rightTip.first"></div>
							</template>
						</div>
					</div>
				</div>
				<div id="studytip-first" class="stoptip" style="height: 696px;">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-second')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-登录千牛.ppt</p>
								<p>
									<a v-if="isOpenPpt.first" class="btn-open" @click="viewPpt('first', false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt('first')">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer"></div>
				</div>
			</el-tab-pane>
			<!--第2步 切换状态-->
			<el-tab-pane name="second">
				<div slot="label" class="tab-slot">
					<p class="title">2、基础设置（上）</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-second" class="video-box">
					<video id="second" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step2.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-second" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-second" class="content">
					<div class="con-left" style="padding: 0;">
						<StepPlayer
							ref="playerSecond"
							:steps="scenarioConfig.second.steps"
							:initial-step-id="scenarioConfig.second.initialStepId"
							:initial-form="scenarioConfig.second.initialForm"
							:show-tip="false"
							@finish="onFinish('second')"
							@guard-failed="onGuardFailed('second', $event)"
							@step-change="(stepId, step, resolvedTip) => onStepChange('second', stepId, step, resolvedTip)"
						/>
					</div>
					<div class="con-right">
						<h3><span class="line"></span>提示</h3>
						<div class="tip-body" v-html="rightTip.second"></div>
					</div>
				</div>
				<div id="studytip-second" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-third')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')" />
							<div class="con-box">
								<p>千牛练习-基础设置（上）.ppt</p>
								<p>
									<a v-if="isOpenPpt.second" class="btn-open" @click="viewPpt('second', false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt('second')">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer2"></div>
				</div>
			</el-tab-pane>
			<!--第3步 快捷短语-->
			<el-tab-pane name="third">
				<div slot="label" class="tab-slot">
					<p class="title">3、基础设置（下）</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-third" class="video-box">
					<video id="third" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step3.mp4" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-third" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-third" class="content">
					<div class="con-left" style="padding: 0;">
						<StepPlayer
							ref="playerThird"
							:steps="scenarioConfig.third.steps"
							:initial-step-id="scenarioConfig.third.initialStepId"
							:initial-form="scenarioConfig.third.initialForm"
							:show-tip="false"
							@finish="onFinish('third')"
							@guard-failed="onGuardFailed('third', $event)"
							@step-change="(stepId, step, resolvedTip) => onStepChange('third', stepId, step, resolvedTip)"
							@request-file="onRequestFile"
						/>
					</div>
					<div class="con-right">
						<h3><span class="line"></span>提示</h3>
						<div class="tip-body" v-html="rightTip.third"></div>
						<p v-if="rightTip.third && rightTip.third.indexOf('下载') !== -1"><a @click="downloadKjdyFile">点击下载“快捷短语.csv”</a></p>
					</div>
				</div>
				<div id="studytip-third" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-four')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-设置快捷短语.ppt</p>
								<p>
									<a v-if="isOpenPpt.third" class="btn-open" @click="viewPpt('third', false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt('third')">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer3"></div>
				</div>
			</el-tab-pane>
			<!--第4步 会话窗口常用功能-->
			<el-tab-pane name="four">
				<div slot="label" class="tab-slot">
					<p class="title">4、会话窗口常用功能</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-four" class="video-box">
					<video id="four" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step4.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-four" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-four" class="content">
					<div class="con-left" style="padding: 0;">
						<StepPlayer
							ref="playerFour"
							:steps="scenarioConfig.four.steps"
							:initial-step-id="scenarioConfig.four.initialStepId"
							:initial-form="scenarioConfig.four.initialForm"
							:show-tip="false"
							@finish="onFinish('four')"
							@guard-failed="onGuardFailed('four', $event)"
							@step-change="(stepId, step, resolvedTip) => onStepChange('four', stepId, step, resolvedTip)"
						/>
					</div>
					<div class="con-right">
						<h3><span class="line"></span>提示</h3>
						<div class="tip-body" v-html="rightTip.four"></div>
					</div>
				</div>
				<div id="studytip-four" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-five')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-会话窗口常用功能.ppt</p>
								<p>
									<a v-if="isOpenPpt.four" class="btn-open" @click="viewPpt('four', false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt('four')">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer4"></div>
				</div>
			</el-tab-pane>
			<!--第5步 智能客服插件(上)-->
			<el-tab-pane name="five">
				<div slot="label" class="tab-slot">
					<p class="title">5、智能客服插件(上)</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-five" class="video-box">
					<video id="five" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step5.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-five" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-five" class="content">
					<div class="con-left" style="padding: 0;">
						<StepPlayer
							ref="playerFive"
							:steps="scenarioConfig.five.steps"
							:initial-step-id="scenarioConfig.five.initialStepId"
							:initial-form="scenarioConfig.five.initialForm"
							:show-tip="false"
							@finish="onFinish('five')"
							@guard-failed="onGuardFailed('five', $event)"
							@step-change="(stepId, step, resolvedTip) => onStepChange('five', stepId, step, resolvedTip)"
						/>
					</div>
					<div class="con-right">
						<h3><span class="line"></span>提示</h3>
						<div class="tip-body" v-html="rightTip.five"></div>
					</div>
				</div>
				<div id="studytip-five" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-six')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-智能客服插件(上).ppt</p>
								<p>
									<a v-if="isOpenPpt.five" class="btn-open" @click="viewPpt('five', false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt('five')">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer5"></div>
				</div>
			</el-tab-pane>
			<!--第6步 智能客服插件(下)-->
			<el-tab-pane name="six">
				<div slot="label" class="tab-slot">
					<p class="title">6、智能客服插件(下)</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-six" class="video-box">
					<video id="six" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step6.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-six" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-six" class="content">
					<div class="con-left" style="padding: 0;">
						<StepPlayer
							ref="playerSix"
							:steps="scenarioConfig.six.steps"
							:initial-step-id="scenarioConfig.six.initialStepId"
							:initial-form="scenarioConfig.six.initialForm"
							:show-tip="false"
							@finish="onFinish('six')"
							@guard-failed="onGuardFailed('six', $event)"
							@step-change="(stepId, step, resolvedTip) => onStepChange('six', stepId, step, resolvedTip)"
						/>
					</div>
					<div class="con-right">
						<h3><span class="line"></span>提示</h3>
						<div class="tip-body" v-html="rightTip.six"></div>
					</div>
				</div>
				<div id="studytip-six" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-seven')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-智能客服插件(下).ppt</p>
								<p>
									<a v-if="isOpenPpt.six" class="btn-open" @click="viewPpt('six', false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt('six')">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer6"></div>
				</div>
			</el-tab-pane>
			<!--第7步 售后客服常用功能-->
			<el-tab-pane name="seven">
				<div slot="label" class="tab-slot">
					<p class="title">7、售后客服常用功能</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-seven" class="video-box">
					<video id="seven" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step7.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-seven" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-seven" class="content">
					<div class="con-left" style="padding: 0;">
						<StepPlayer
							ref="playerSeven"
							:steps="scenarioConfig.seven.steps"
							:initial-step-id="scenarioConfig.seven.initialStepId"
							:initial-form="scenarioConfig.seven.initialForm"
							:show-tip="false"
							@finish="onFinish('seven')"
							@guard-failed="onGuardFailed('seven', $event)"
							@step-change="(stepId, step, resolvedTip) => onStepChange('seven', stepId, step, resolvedTip)"
						/>
					</div>
					<div class="con-right">
						<h3><span class="line"></span>提示</h3>
						<div class="tip-body" v-html="rightTip.seven"></div>
					</div>
				</div>
				<div id="studytip-seven" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-eight')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-售后客服常用功能.ppt</p>
								<p>
									<a v-if="isOpenPpt.seven" class="btn-open" @click="viewPpt('seven', false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt('seven')">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer7"></div>
				</div>
			</el-tab-pane>
			<!--第8步 退出千牛-->
			<el-tab-pane name="eight">
				<div slot="label" class="tab-slot">
					<p class="title">8、退出千牛</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-eight" class="video-box">
					<video id="eight" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step8.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
				</div>
				<div id="stoptip-eight" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-eight" class="content">
					<div class="con-left" style="padding: 0;">
						<StepPlayer
							ref="playerEight"
							:steps="scenarioConfig.eight.steps"
							:initial-step-id="scenarioConfig.eight.initialStepId"
							:initial-form="scenarioConfig.eight.initialForm"
							:show-tip="false"
							@finish="onFinish('eight')"
							@guard-failed="onGuardFailed('eight', $event)"
							@step-change="(stepId, step, resolvedTip) => onStepChange('eight', stepId, step, resolvedTip)"
						/>
					</div>
					<div class="con-right">
						<h3><span class="line"></span>提示</h3>
						<div class="tip-body" v-html="rightTip.eight"></div>
					</div>
				</div>
				<div id="studytip-eight" class="stoptip" v-if="OnInline == 'false'">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>你已完成千牛的功能学习，<br>接下来请完成《千牛模拟实操》。</p>
						<a class="startstudy" href="/tjkStudy/simulate/newqianniuexam" style="width: 160px;">去完成千牛模拟实操</a>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-退出千牛.ppt</p>
								<p>
									<a v-if="isOpenPpt.eight" class="btn-open" @click="viewPpt('eight', false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt('eight')">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer8"></div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import PDFObject from '../../assets/js/pdfobject.min'
import { getScenarioConfig } from './newQianNiuScenarios'
import StepPlayer from '@/components/simulate/StepPlayer.vue'

const TAB_KEYS = ['first', 'second', 'third', 'four', 'five', 'six', 'seven', 'eight']
const PDF_VIEWER_IDS = { first: 'pdf_viewer', second: 'pdf_viewer2', third: 'pdf_viewer3', four: 'pdf_viewer4', five: 'pdf_viewer5', six: 'pdf_viewer6', seven: 'pdf_viewer7', eight: 'pdf_viewer8' }
const PDF_URLS = {
	first: '//res.study.itaojin.cn/2024-12/661361ebec2f434fb859625f84480ea0.pdf',
	second: '//res.study.itaojin.cn/2024-12/e203c6b30e9049818094cee869c17026.pdf',
	third: '//res.study.itaojin.cn/2024-12/6fa4070d7418446690ce19576261afe5.pdf',
	four: '//res.study.itaojin.cn/2024-12/8a2815e9246840c2be40e87ac705da18.pdf',
	five: '//res.study.itaojin.cn/2024-12/52d4b0fc262c4b058ddee379d625552f.pdf',
	six: '//res.study.itaojin.cn/2024-12/5490dc4ddc6c4e73897aaa3332e5a3d1.pdf',
	seven: '//res.study.itaojin.cn/2024-12/4183c223f03d4892a6768486996d5455.pdf',
	eight: '//res.study.itaojin.cn/2024-12/d138c13a5f304a0198294afb2495384b.pdf'
}

export default {
	components: { StepPlayer },
	data() {
		const rightTip = {}
		const isOpenPpt = {}
		TAB_KEYS.forEach(k => { rightTip[k] = ''; isOpenPpt[k] = false })
		return {
			OnInline: 'false',
			tabIndex: 1,
			tabCurrent: 'first',
			isShowBtn: [],
			scenarioConfig: getScenarioConfig(),
			rightTip,
			isOpenPpt,
			currentStepId: TAB_KEYS.reduce((m, k) => { m[k] = ''; return m }, {}),
			showLoginPassword: false
		}
	},
	mounted() {
		document.getElementById(this.tabCurrent).addEventListener('ended', () => { //该视频播放是否已结束
			$('#startvideo').hide();
			$('#stoptip-' + this.tabCurrent).show();
			this.$set(this.isShowBtn, this.tabCurrent, true)
		}, false);
		document.getElementById(this.tabCurrent).addEventListener('play', () => { //该视频播放是否已结束
			$('#startvideo').hide();
		}, false);
		// 页面初始化时重置各关卡的内容显示与 StepPlayer 状态
		this.initAll()
	},
	directives: {
		focus: {
			inserted: function (el, { value }) {
				if (value) {
					el.focus();
				}
			}
		}
	},
	created() {
		if (this.$route.query.OnInline) {
			this.OnInline = this.$route.query.OnInline
		}
	},
	methods: {
		resetFocus() {},
		onFinish(tabKey) {
			this.addRecord('END')
			const self = this
			setTimeout(() => {
				$('#studytip-' + tabKey).show()
			}, 2000)
		},
		onStepChange(tabKey, stepId, step, resolvedTip) {
			this.$set(this.currentStepId, tabKey, stepId)
			if (tabKey === 'first' && stepId !== 'login') {
				this.showLoginPassword = false
			}
			this.$set(this.rightTip, tabKey, resolvedTip || '')
		},
		onGuardFailed(tabKey, res) {
			this.$alert(res && res.msg ? res.msg : '校验未通过')
		},
		onRequestFile() {
			this.$refs.fileInputThird && this.$refs.fileInputThird.click()
		},
		onThirdFileChange(evt) {
			const file = evt.target.files && evt.target.files[0]
			if (!file || (file.name && file.name.indexOf('快捷短语') < 0)) {
				this.$alert('请选择你下载的“快捷短语.csv”模板文件')
				return
			}
			const player = this.$refs.playerThird
			if (player) player.go('s3_11')
			setTimeout(() => {
				if (this.$refs.fileInputThird) this.$refs.fileInputThird.value = ''
			}, 300)
		},
		downloadKjdyFile() {
			const path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'
			fetch(path).then(r => r.blob()).then(blob => {
				const a = document.createElement('a')
				a.href = window.URL.createObjectURL(blob)
				a.download = '快捷短语.csv'
				a.click()
				a.remove()
			})
		},
		/******************/
		formatDate: function (value) {
			let date = new Date(value);
			let y = date.getFullYear();
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? ('0' + MM) : MM;
			let d = date.getDate();
			d = d < 10 ? ('0' + d) : d;
			let h = date.getHours();
			h = h < 10 ? ('0' + h) : h;
			let m = date.getMinutes();
			m = m < 10 ? ('0' + m) : m;
			let s = date.getSeconds();
			s = s < 10 ? ('0' + s) : s;
			return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
		},
		//第1步-开始播放视频
		startVideo() {
			document.getElementById('first').play();
			$('#startvideo').hide();
		},
		//初始化所有tab内容
		initAll() {
			$('#startvideo').hide()
			this.isShowBtn = []
			TAB_KEYS.forEach(k => {
				this.isOpenPpt[k] = false
				this.rightTip[k] = ''
				const id = PDF_VIEWER_IDS[k]
				if (id && $('#' + id).length) $('#' + id).height('0')
			})
			const playerRefs = ['playerFirst', 'playerSecond', 'playerThird', 'playerFour', 'playerFive', 'playerSix', 'playerSeven', 'playerEight']
			playerRefs.forEach((ref, i) => {
				const player = this.$refs[ref]
				if (player && this.scenarioConfig[TAB_KEYS[i]]) {
					player.reset(this.scenarioConfig[TAB_KEYS[i]].initialStepId)
				}
			})
			$('.content').each(function () { $(this).css('display', 'none') }) //todo none
			$('.stoptip').each(function () { $(this).hide() })
			$('.video-box').not('#video-' + this.tabCurrent).each(function () { $(this).hide() })
			$('#video-' + this.tabCurrent).show() //todo show
		},
		//tab切换
		handleClick(tab, event) {
			this.tabIndex = parseInt(tab.index) + 1
			//内容初始化
			this.initAll();
			this.resetFocus();
			document.getElementById(this.tabCurrent).play();
			$('video').not('#' + this.tabCurrent).each(function (i) {
				var tabId = $(this).attr('id');
				document.getElementById(tabId).pause();
				document.getElementById(tabId).currentTime = 0;
			});
			document.getElementById(this.tabCurrent).addEventListener('ended', () => { //该视频播放是否已结束
				$('#stoptip-' + this.tabCurrent).show();
				this.$set(this.isShowBtn, this.tabCurrent, true);
			}, false);
		},
		//展开/收起ppt（tabKey: first|second|third|four|five|six|seven|eight, bol: false 表示收起）
		viewPpt(tabKey, bol) {
			if (this.isOpenPpt[tabKey] === true || bol === false) {
				this.$set(this.isOpenPpt, tabKey, false)
				const id = PDF_VIEWER_IDS[tabKey]
				if (id && $('#' + id).length) $('#' + id).height('0')
			} else {
				this.$set(this.isOpenPpt, tabKey, true)
				const id = PDF_VIEWER_IDS[tabKey]
				const url = PDF_URLS[tabKey]
				if (id && url && PDFObject.supportsPDFs) {
					$('#' + id).height('700px')
					PDFObject.embed(url, '#' + id, {
						pdfOpenParams: { navpanes: 0, toolbar: 0, statusbar: 0, view: 'FitV', pagemode: 'thumbs', page: 1 },
						forcePDFJS: true,
						PDFJS_URL: '//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html'
					})
				}
			}
		},

		
		//重播
		restartVideo() {
			document.getElementById(this.tabCurrent).play();
			$('#stoptip-' + this.tabCurrent).hide();
		},
		//开始实操练习
		startStudy() {
			document.getElementById(this.tabCurrent).pause()
			$('#stoptip-' + this.tabCurrent).hide()
			$('#video-' + this.tabCurrent).hide()
			this.$set(this.isShowBtn, this.tabCurrent, false)
			$('#content-' + this.tabCurrent).css('display', 'flex')
			const ref = 'player' + this.tabCurrent.charAt(0).toUpperCase() + this.tabCurrent.slice(1)
			const player = this.$refs[ref]
			const cfg = this.scenarioConfig[this.tabCurrent]
			if (player && cfg) {
				player.reset(cfg.initialStepId)
			}
			this.addRecord('START')
		},
		//下一关
		studyNext(next) {
			this.initAll()
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide()
			$('#content-' + this.tabCurrent).hide()
			$('#video-' + this.tabCurrent).show()
			document.getElementById(this.tabCurrent).currentTime = 0
			$(next).click()
		},
		restartStudy() {
			const cfg = this.scenarioConfig[this.tabCurrent]
			if (!cfg) return
			const ref = 'player' + this.tabCurrent.charAt(0).toUpperCase() + this.tabCurrent.slice(1)
			const player = this.$refs[ref]
			if (player) player.reset(cfg.initialStepId)
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide()
			this.addRecord('START')
		},
		/*
		 * @description 时间格式化
		 * @param { date } date 时间或时间戳
		 * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
		 *
		 * @return { string } 格式化后的字符串
		*/
		dateFormatString(date, format) { // 时间格式化
			var date = new Date(date),
				o = {
					"M+": date.getMonth() + 1,
					"d+": date.getDate(),
					"h+": date.getHours(),
					"m+": date.getMinutes(),
					"s+": date.getSeconds(),
					"q+": Math.floor((date.getMonth() + 3) / 3),
					"S": date.getMilliseconds()
				};
			if (/(y+)/.test(format)) {
				format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
			}

			for (var k in o) {
				if (new RegExp("(" + k + ")").test(format)) {
					format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
				}
			}
			return format;
		},
		/**
		 * 获取从今日开始的前 n 天的日期
		 */
		getLastDaysFromToday(n) {
			let lastDays = new Date().setDate((new Date().getDate() - n));
			let lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
			return lastDaysStr;
		},
		//记录接口
		addRecord(type) {
			var data = {
				exerciseType: 'QIAN_NIU',
				stepSeq: this.tabIndex,
				exerciseAction: type
			}
			this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res => {
				var result = res.data
				if (result.success) {
					if (this.tabIndex == 8 && type == 'END') {
						window.parent['goBack']();
					}
				} else {
					this.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 1000
					})
				}
			}, res => {
				this.$message({
					message: "网络繁忙，请稍后重试！",
					type: 'error',
					center: true,
					duration: 1000
				})
			})
		}
	}
}
</script>
<style lang="less" scoped>
.account-table {
	border-top: 1px solid #000000;
	border-left: 1px solid #000000;
	margin: 10px;
	border-spacing: inherit;

	>tr>td {
		border-right: 1px solid #000000;
		border-bottom: 1px solid #000000;
		padding: 5px;
	}
}
/deep/ .el-tabs__content {
	height: 100% !important;
}
.con-left {
	background: none !important;
	flex: 1 1 auto;
	min-width: 1;
}
.con-right {
	width: 170px;
	flex: 0 0 170px;
}
.stoptip {
	width: 100% !important;
	height: 100% !important;
}
.video-box {
	width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// ./src/page/simulate/newQianNiu.vue